<template>
    <div>
        <a-upload name="file" :file-list="list" list-type="picture-card" class="avatar-uploader" :show-upload-list="true" action="/api/file/upload" :before-upload="beforeUpload" @change="handleChange" @preview="handlePreview" style="margin: 0" :disabled="disabled">
            <div v-if="list.length < 5">
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                    上传
                </div>
            </div>
        </a-upload>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>
<script>
// function getBase64 (img, callback) {
//   const reader = new FileReader()
//   reader.addEventListener('load', () => callback(reader.result))
//   reader.readAsDataURL(img)
// }
export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            list: [],
            previewImage: '',
            previewVisible: false,

            temporaryValue: null //组件使用的变量
        };
    },
    created() {},
    watch: {
        //监听父组件传值,并且监听初始化
        value: {
            handler: function(val) {
                this.temporaryValue = val; //将父组件的传值赋给绑定的值
                let temporaryList = JSON.parse(val);
                console.log('ddddddddddddddddddddddd');
                this.list = temporaryList.map(item => {
                    return {
                        uid: item,
                        // id: item,
                        id: item,
                        status: 'done',
                        url: item ? `/api/file/preview/${item}` : ''
                    };
                });
            },
            immediate: true
        },
        // 监听子组件的值改变,并且返回给父组件
        temporaryValue(val) {
            console.log(val, '最终结果=================');
            this.$emit('input', val); //将绑定的值反给父组件
        }
    },
    methods: {
        handleChange(info) {
            console.log(info, ';;;;;;;;;;;;;;;;;;;;;;;;');
            // if (info.file.status === 'done') {
            //     this.list = [];
            //     info.fileList.forEach(item => {
            //         if (item.response) {
            //             this.list.push({
            //                 id: item.response.data.uuid,
            //                 name: item.response.data.uuid,
            //                 url: item.response.data.uuid ? `/api/file/preview/${item.response.data.uuid}` : ''
            //             });
            //         }
            //     });
            // } else {
            this.list = info.fileList;
            let arry = [];
            if (info.file.status == 'done' || info.file.status == 'removed') {
                info.fileList.forEach(element => {
                    console.log('iiiiiiiiiiiiiiiiiiii');
                    if (element.response) {
                        arry.push(element.response.data.uuid);
                    } else if (element.id) {
                        arry.push(element.id);
                    }
                });
                this.temporaryValue = JSON.stringify(arry);
            }
        },
        // handleChange(info) {
        //     if (info.file.status === 'done') {
        //         console.log(info, ';;;;;;;;;;;;;;;;;;;;;;;;');
        //         this.list = info.fileList.map(item => {
        //             if (item.response) {
        //                 return {
        //                     ...item,
        //                     id: item.response.data.uuid,
        //                     name: item.response.data.uuid,
        //                     url: item.response.data.uuid ? `/api/file/preview/${item.response.data.uuid}` : ''
        //                 };
        //             } else {
        //                 return item;
        //             }
        //         });
        //         console.log(this.list, '返回值');
        //     } else {
        //         this.list = info.fileList;
        //     }

        //     // if (info.file.status === 'uploading') {
        //     //   this.loading = true
        //     //   return
        //     // }
        //     // if (info.file.status === 'done') {
        //     //   this.loading = false
        //     // }
        // },
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
            if (!isJpgOrPng) {
                this.$message.error('You can only upload JPG file!');
            }
            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error('Image must smaller than 10MB!');
            }
            return isJpgOrPng && isLt2M;
        },
        async handlePreview(file) {
            this.previewImage = file.url;
            this.previewVisible = true;
        },
        handleCancel() {
            this.previewVisible = false;
        }
    }
};
</script>
<style scoped>
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/ImgUploadSP/ImgUpload.vue